import { render, staticRenderFns } from "./colorProvider.vue?vue&type=template&id=1f03f7c8"
import script from "./colorProvider.vue?vue&type=script&lang=js"
export * from "./colorProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports